export default {
  setAnswers (state, payload) {
    state.answers = payload
  },
  setQuestionFlowData (state, payload) {
    const availableQuestions = payload?.questions?.filter(question => question.enabled || question.required)
    state.leadGenQuestions = availableQuestions
    state.totalSteps = availableQuestions?.length || 0
    state.propertyType = payload?.type
  },
  setOrgGuid (state, payload) {
    state.orgGuid = payload
  },
  setOrgType (state, payload) {
    state.orgType = payload
  },
  setSettings (state, payload) {
    state.settings = payload
  },
  setCurrentQuestionIndex (state, payload) {
    state.currentQuestionIndex = payload
  }
}
